var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('gmap-map',{ref:"mapRef",class:[_vm.getClass()],attrs:{"center":_vm.center,"zoom":12,"options":_vm.mapOptions},on:{"click":_vm.handleMapClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }